
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-white border-t border-gray-100 py-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center">
          <p className="text-sm font-light tracking-wider text-gray-600 uppercase">
            © 2024 PEDRO FAERSTEIN. {t('allRightsReserved')}.
          </p>
          <div className="mt-4">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xs font-light tracking-wider text-gray-500 uppercase hover:text-gray-700 transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
